const AccordionSectionType = Object.freeze({
  SUMMARY: 'SUMMARY',
  SOUND_BITE: 'SOUND_BITE',
  COMMENT: 'COMMENT',
  DOMAIN: 'DOMAIN',
  TOP_AUTHOR: 'TOP_AUTHOR'
})
export default AccordionSectionType
export type AccordionSectionTypeStrings = typeof AccordionSectionType[keyof typeof AccordionSectionType]
// RESERVE BELOW
